/* globals Vimeo */

import Vue from 'vue';
import { gsap } from 'gsap/all';

Vue.component('project-header-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            player: null,
            isPlaying: false,
            poster: null,
            timings: {
                total: 0,
                current: 0,
            },
            seeker: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        const landscapeVideo = document.getElementById('landscape-video');

        if (landscapeVideo) {
            landscapeVideo.addEventListener('play', this.onVideoPlay);
            landscapeVideo.addEventListener('pause', this.onVideoPause);
        }

        this.seeker = this.$refs.seeker;
        this.iframe = this.$el.querySelector('iframe');
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initPlayer() {
            if (!this.iframe) {
                return;
            }

            this.iframe.src = this.iframe.dataset.src;
            this.player = new Vimeo.Player(this.iframe);

            EventBus.$on('header-scroll-down', this.pauseVideo);

            this.player.on('timeupdate', (event) => {
                if (this.isPlaying && !this.rangeUpdate) {
                    // Update the slider value
                    this.seeker.value = Math.round(event.percent * 100);
                    gsap.killTweensOf('#seeker');
                    gsap.to('#seeker', {
                        duration: 0.1,
                        width: `${Math.round(event.percent * 100)}%`,
                    });

                    this.timings.current = event.currentTime;
                    this.timings.total = event.duration;
                }
            });
        },

        getPoster() {
            if (!this.poster) {
                this.poster = document.getElementById('header-poster-image');
            }

            return this.poster;
        },

        pauseVideo() {
            const poster = this.getPoster();

            this.onVideoPause();
            this.player.pause();
            // console.log(poster);
            if (poster) {
                poster.style.display = 'block';
            }
        },

        onPlay() {
            const poster = this.getPoster();

            if (!this.player) {
                this.initPlayer();
            }

            this.player.getPaused().then((paused) => {
                if (!paused) {
                    this.onVideoPause();
                    this.player.pause();
                    if (poster) {
                        // poster.style.display = "block";
                    }

                    return;
                }

                if (this.$root.mobileVideo.matches) {
                    this.player.requestFullscreen();
                }

                this.player.play();

                this.onVideoPlay();
                if (poster) {
                    poster.style.display = 'none';
                }
            }).catch((error) => {
                //
            });
        },

        playPortrait() {
            const portraitVideo = document.getElementById('portrait-video');
            const poster = document.getElementById('header-poster-image');
            if (portraitVideo.paused) {
                portraitVideo.play();
                poster.style.display = 'none';
            } else {
                portraitVideo.pause();
            }
        },

        playLandscape() {
            const landscapeVideo = document.getElementById('landscape-video');
            const poster = document.getElementById('header-poster-image');

            if (landscapeVideo.paused) {
                landscapeVideo.play();
                poster.style.display = 'none';
            } else {
                landscapeVideo.pause();
            }
        },

        onVideoPlay() {
            // this.progressLoop();
            this.isPlaying = true;
            EventBus.$emit('hero-video-play');
        },

        onVideoPause() {
            this.isPlaying = false;
            EventBus.$emit('hero-video-pause');
        },

        onProgressBarClick(event) {

        },

        progressLoop() {
            const progressBar = document.getElementById('progress');
            const landscapeVideo = document.getElementById('landscape-video');
            // eslint-disable-next-line no-undef
            player.getDuration().then((duration) => {
                // `duration` indicates the duration of the video in seconds
            });

            setInterval(() => {
                progressBar.style.width = `${Math.round((landscapeVideo.currentTime / landscapeVideo.duration) * 100)}%`;
            });
        },

        onRangeChange(event) {
            this.rangeUpdate = true;

            // Calculate the new time
            const time = this.timings.total * (event.currentTarget.value / 100);

            // Update the video time
            // this.video.currentTime = time;
            this.player.setCurrentTime(time).then((seconds) => {
                // `seconds` indicates the actual time that the player seeks to
            }).catch((error) => {
                switch (error.name) {
                case 'RangeError':
                    // The time is less than 0 or greater than the video's duration
                    break;

                default:
                    // Some other error occurred
                    break;
                }
            });

            this.rangeUpdate = false;
        },

        onVideoTimeupdate() {
            if (!this.video.paused && !this.rangeUpdate && this.video) {
                // Calculate the slider value
                const value = (100 / this.video.duration) * this.video.currentTime;

                // Update the slider value
                this.seeker.value = value;

                this.progressWidth = (document.getElementById('seek-input').offsetWidth / 100) * this.seeker.value;
                gsap.killTweensOf('#seeker');
                gsap.set('#seeker', { width: this.progressWidth });

                this.timings.current = this.video.currentTime;
                this.timings.total = this.video.duration;
            }
        },
    },
});
